



























import { debounceProcess } from "@/helpers/debounce";
import { usePurchaseOrder } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { PurchaseOrderResponseDto } from "@/models/interface/purchase-order";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SelectAvailPo extends Vue {
  @Prop({ required: true, type: String, default: "" })
  value!: string;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  options: Array<Option<PurchaseOrderResponseDto>> = [];
  loading = false;

  created(): void {
    this.onSearch = debounceProcess(this.onSearch);

    this.fetchOptions();
  }

  fetchOptions(params: RequestQueryParams = new RequestQueryParams()): void {
    const { findAllAvailableReceive, toOptionsNew } = usePurchaseOrder();
    this.loading = true;
    findAllAvailableReceive(params)
      .then(({ data }) => {
        this.options = toOptionsNew(data);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  onSearch(val = ""): void {
    const { searchBy } = usePurchaseOrder();
    const params = new RequestQueryParams();
    params.search = searchBy({ docNumber: val });

    this.fetchOptions(params);
  }

  findOption(value: string): Option<PurchaseOrderResponseDto> | undefined {
    return this.options.find(e => value === e.value);
  }
}
